import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import PropTypes from 'prop-types';

import Input from '../../../../../components/input';

class VCode extends React.PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        value: PropTypes.string,
        error: PropTypes.bool,
        getCode: PropTypes.func,
        onKeydown: PropTypes.func,
        errorMessage: PropTypes.any,
    };

    state = {
        txt: '获取验证码',
        timeCount: 59,
        btnDisable: false,
    };

    startCountDown = () => {
        let timeCount = this.state.timeCount;

        // console.log(timeCount);
        this.setState({
            txt: `${60}s`,
            btnDisable: true,
        });
        const timer = setInterval(() => {
            this.setState(
                {
                    txt: `${timeCount}s`,
                    timeCount: timeCount--,
                },
                () => {
                    if (timeCount < 0) {
                        clearInterval(timer);
                        this.setState({
                            txt: '获取验证码',
                            timeCount: 60,
                            btnDisable: false,
                        });
                    }
                },
            );
        }, 1000);
    };

    // 点击获取验证码
    getCode = () => {
        const { btnDisable } = this.state;

        if (btnDisable) {
            return;
        }

        this.props.getCode(this.startCountDown);
    };

    render() {
        const { txt, btnDisable } = this.state;
        const { onChange, onBlur, value, error, errorMessage } = this.props;
        const config = {
            onChange,
            onBlur,
            value,
            error,
        };

        console.log(this.props);

        return (
            <div className={styles.vCode}>
                <div className="clearfix" style={{ marginBottom: 16 }}>
                    <div
                        className={`${styles.getMsgPinBtn} ${btnDisable ? styles.disable : ''}`}
                        onClick={this.getCode}>
                        {txt}
                    </div>
                    <span className={styles.tip}>24小时内发送验证码不能过于频繁</span>
                </div>
                <label>
                    <span className={styles.label}>短信验证码</span>
                    <div className={styles.input}>
                        <Input {...config} onKeydown={this.props.onKeydown} />
                    </div>
                </label>
                {error ? <div className={styles.error}>{errorMessage}</div> : null}
            </div>
        );
    }
}

export default errorBoundary(VCode);
